import styled from 'styled-components';

import { Text } from '@gympass/yoga';

import * as BreadcrumStyle from 'components/Breadcrumb/styles';
import * as EndUserStyle from 'pages/EndUser/styles';

export const AssessmentAnswers = styled.div`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const AssessmentTitle = styled(Text.H5)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const AssessmentIntroduction = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textDisabled};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const CrumbContainer = styled(BreadcrumStyle.CrumbContainer)``;

export const Divisor = styled(EndUserStyle.Divisor)``;

export const TabsContainer = styled(EndUserStyle.TabsContainer)``;

export const UserInfoContainer = styled(EndUserStyle.UserInfoContainer)``;
